"use strict";

var table = {
  5: 95.00,
  10: 95.00,
  15: 95.00,
  20: 95.00,
  25: 95.00,
  30: 100.00,
  35: 100.00,
  40: 105.00,
  45: 105.00,
  50: 110.00,
  55: 115.00,
  60: 115.00,
  65: 120.00,
  70: 120.00,
  75: 125.00,
  80: 130.00,
  85: 130.00,
  90: 135.00,
  95: 135.00,
  100: 140.00,
  105: 145.00,
  110: 145.00,
  115: 150.00,
  120: 150.00,
  125: 155.00,
  130: 160.00,
  135: 160.00,
  140: 165.00,
  145: 165.00,
  150: 170.00,
  155: 175.00,
  160: 175.00,
  165: 180.00,
  170: 180.00,
  175: 185.00,
  180: 190.00,
  185: 190.00,
  190: 195.00,
  195: 195.00,
  200: 200.00,
  205: 205.00,
  210: 205.00,
  215: 210.00,
  220: 210.00,
  225: 215.00,
  230: 215.00,
  235: 220.00,
  240: 225.00,
  245: 230.00,
  250: 235.00,
  255: 240.00,
  260: 245.00,
  265: 250.00,
  270: 255.00,
  275: 260.00,
  280: 265.00,
  285: 270.00,
  290: 275.00,
  295: 280.00,
  300: 285.00,
  305: 290.00,
  310: 295.00,
  315: 300.00,
  320: 305.00,
  325: 310.00,
  330: 315.00,
  335: 320.00,
  340: 325.00,
  345: 330.00,
  350: 335.00,
  355: 340.00,
  360: 345.00,
  365: 350.00,
  370: 355.00,
  375: 360.00,
  380: 365.00,
  385: 370.00,
  390: 375.00,
  395: 380.00,
  400: 385.00,
  405: 390.00,
  410: 395.00,
  415: 400.00,
  420: 405.00,
  425: 410.00,
  430: 415.00,
  435: 420.00,
  440: 425.00,
  445: 430.00,
  450: 435.00,
  455: 440.00,
  460: 445.00,
  465: 450.00,
  470: 455.00,
  475: 460.00,
  480: 465.00,
  485: 470.00,
  490: 475.00,
  495: 480.00,
  500: 485.00,
  505: 490.00,
  510: 495.00,
  515: 500.00,
  520: 505.00,
  525: 510.00,
  530: 515.00,
  535: 520.00,
  540: 525.00,
  545: 530.00,
  550: 535.00,
  555: 540.00,
  560: 545.00,
  565: 550.00,
  570: 555.00,
  575: 560.00,
  580: 565.00,
  585: 570.00,
  590: 575.00,
  595: 580.00,
  600: 585.00,
  605: 590.00,
  610: 595.00,
  615: 600.00,
  620: 605.00,
  625: 610.00,
  630: 615.00,
  635: 620.00,
  640: 625.00,
  645: 630.00,
  650: 635.00,
  655: 640.00,
  660: 645.00,
  665: 650.00,
  670: 655.00,
  675: 660.00,
  680: 665.00,
  685: 670.00,
  690: 675.00,
  695: 680.00,
  700: 685.00,
  705: 690.00,
  710: 695.00,
  715: 700.00,
  720: 705.00,
  725: 710.00,
  730: 715.00,
  735: 720.00,
  740: 725.00,
  745: 730.00,
  750: 735.00,
  755: 740.00,
  760: 745.00,
  765: 750.00,
  770: 755.00,
  775: 760.00,
  780: 765.00,
  785: 770.00,
  790: 775.00,
  795: 780.00,
  800: 785.00,
  805: 790.00,
  810: 795.00,
  815: 800.00,
  820: 805.00,
  825: 810.00,
  830: 815.00,
  835: 820.00,
  840: 825.00,
  845: 830.00,
  850: 835.00,
  855: 840.00,
  860: 845.00,
  865: 850.00,
  870: 855.00,
  875: 860.00,
  880: 865.00,
  885: 870.00,
  890: 875.00,
  895: 880.00,
  900: 885.00
};

module.exports = function (accumulator, order, product, component) {
  var quantity = component.quantity;
  var addition = table[quantity] || 0;
  return (parseFloat(accumulator, 10) || 0) + addition;
};